import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "420px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

// Hard block shown when the camera never opens at all (getUserMedia failed after bounded
// retries) - distinct from NoFaceModal, which only ever fires once a frame has actually been
// captured. No dismiss/backdrop-close and no "continue anyway" option on purpose - the
// candidate cannot proceed with the exam on a device with no working camera. Two states:
// still within the retry budget (Retry Camera only), or `terminal` once that budget is
// exhausted (device deemed incompatible - only way out is back to the dashboard, no exam
// abort/violation is recorded, this is not a proctoring-violation termination).
export default function CameraFailedModal({ open, terminal, onRetry, onGoToDashboard }) {
  const classes = useStyles();

  return (
    <div>
      <Modal
        disableEnforceFocus={true}
        disableEscapeKeyDown
        aria-labelledby="camera-failed-modal-title"
        aria-describedby="camera-failed-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            {terminal ? (
              <>
                <h3 id="camera-failed-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Device Not Compatible
                </h3>
                <p id="camera-failed-modal-description">
                  Your device is not compatible for proctoring. Please change your device to continue.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                  <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onGoToDashboard}>
                    <strong>Ok</strong>
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 id="camera-failed-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Camera Not Detected
                </h3>
                <p id="camera-failed-modal-description">
                  We couldn't access your camera, so you can't continue until this is fixed. This is usually a browser/OS camera permission that's blocked, or another app currently using your camera.
                </p>
                <p style={{ marginTop: "10px" }}>
                  Please check your camera permission and close any other app using the camera, then retry.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                  <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onRetry}>
                    <strong>Retry Camera</strong>
                  </button>
                </div>
              </>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
